import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <div style={pageStyle}>
      <header style={headerStyle}>
        <h1 style={{ fontSize: '2.2rem', color: '#2563eb', fontWeight: 'bold' }}>מדיניות פרטיות ואבטחת מידע</h1>
        <p style={{ color: '#666' }}>דרייבר.ישראל - מחויבים לפרטיות שלך</p>
        <button onClick={() => navigate('/')} style={backButtonStyle}>➜ חזרה לדף הבית</button>
      </header>

      <main style={contentStyle}>
        <p><strong>עודכן לאחרונה: מאי 2026</strong></p>

        <section>
          <h3>🛡️ המחויבות שלנו</h3>
          <p>דרייבר.ישראל מתחייבת לפעול בשקיפות ובהתאם לחוק הגנת הפרטיות, התשמ"א-1981.</p>
        </section>

        <section>
          <h3>1. המידע שאנו אוספים</h3>
          <p>אנו אוספים שם, מספר טלפון, כתובות איסוף ומסירה, ומיקום בזמן אמת (לשליחים מקוונים בלבד). המידע משמש אך ורק לחיבור בין שולח לשליח ולמעקב אחרי המשלוח. <strong>איננו מוכרים מידע לצד ג'.</strong></p>
        </section>

        <section>
          <h3>2. מיקום בזמן אמת</h3>
          <p>מיקום השליח משודר רק כאשר הוא במצב "מקוון", ומאפשר לשולח לעקוב אחרי המשלוח. המיקום נמחק אוטומטית ברגע שהשליח עובר למצב "לא מקוון" או סוגר את האפליקציה.</p>
        </section>

        <section>
          <h3>3. Google AdSense ו-Cookies</h3>
          <p>אנו נעזרים ב-Google AdSense לתחזוקת השירות. גוגל משתמשת בעוגיות להצגת מודעות מותאמות. ניתן לנהל זאת דרך הגדרות הדפדפן.</p>
        </section>

        <section>
          <h3>4. אבטחה</h3>
          <p>האתר מוגן באמצעות SSL ו-Google reCAPTCHA למניעת בוטים וספאם.</p>
        </section>
      </main>
    </div>
  );
};

const pageStyle = { fontFamily: "'Varela Round', sans-serif", direction: 'rtl', padding: '20px', backgroundColor: '#f4f7f6', minHeight: '100vh' };
const headerStyle = { textAlign: 'center', marginBottom: '30px', padding: '20px' };
const contentStyle = { maxWidth: '850px', margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', lineHeight: '1.8', color: '#444' };
const backButtonStyle = { marginTop: '20px', padding: '12px 25px', border: 'none', borderRadius: '50px', backgroundColor: '#2563eb', color: 'white', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 15px rgba(37,99,235,0.3)' };

export default PrivacyPolicy;
